import { Component, OnInit } from '@angular/core';
import { Bus } from './../../../models/bus';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Passenger } from './../../../models/passenger';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;
import * as moment from 'moment';
import { error } from 'jquery';

@Component({
  selector: 'app-subscription-add-passenger',
  templateUrl: './subscription-add-passenger.component.html',
  styleUrls: ['./subscription-add-passenger.component.css']
})
export class SubscriptionAddPassengerComponent implements OnInit {

  isAssistant: boolean;
  routeBase: string;
  PgNo: any;
  PgLen: any;

  passenger: Passenger;
  clients: any[];
  clientId: any;
  schools: any[];
  buses: any[];
  school: any;
  filterJourney = {
    date: new Date(),
    inputFrom: '',
    inputTo: '',
    timeInterval: [],
  };
  JourneyloadData: any;

  public clientsData: any[];
  public schoolsData: any[];
  public busesData: any[];
  public subscriptionsData: any[];
  public inscriptionStatusData: Array<Select2OptionData>;
  pnotify = undefined;
  option: any;
  map: any;
  markers: any[];
  markerBounds: any;
  isResponsible = false;
  passagerLinkMaps: any;
  phonePassagerInvalide: any = 0;
  linkInvalide: any = 0;
  distanceInvalid: any = 0;
  inscriptionTypeSelected: any;
  firstNamesRegistrationNumbers = [{ firstname: '', RegistrationNumber: '' }];

  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
    ) {
    this.isAssistant = false;
    //this.routeBase = 'passenger';
    this.routeBase = 'subscription';
    this.route.params.subscribe(params => {
      this.PgNo = params['PgNo'];
      this.PgLen = params['PgLen'];
    });
    this.passenger = new Passenger();
    this.initClientSelect();
    this.initSchoolSelect();
    this.subscriptionsData = [
      {
        id: 'Aller/Retour',
        text: 'Aller/Retour',
        selected: this.passenger.subscription == 'Aller/Retour' ? true : false
      },
      {
        id: 'Aller',
        text: 'Aller',
        selected: this.passenger.subscription == 'Aller' ? true : false
      },
      {
        id: 'Retour',
        text: 'Retour',
        selected: this.passenger.subscription == 'Retour' ? true : false
      },
    ];

    this.inscriptionStatusData = [
      {
        id: 'PNV',
        text: 'Position non valide'
      },
      {
        id: 'Attente',
        text: 'Attente validation'
      },
      {
        id: 'Valid',
        text: 'Validé'
      },
    ];

    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        //this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant ? true : false;
        this.passenger.isAssistant = this.isAssistant;
        this.passenger.count = data.isAssistant ? 1 : 0;
      });
    this.initMap();
    this.map.fitBounds(this.markerBounds);
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
      });
    }
  }
  clientChanged(e: any) {
    this.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
    });
  }
  schoolChanged(e: any) {
    this.passenger.schoolId = e.value;
    this.schools.forEach((school) => {
      if (school.id == this.passenger.schoolId) {
        this.school = school;
      }
    });
    this.initMap();
    this.initBusSelect();
  }
  initBusSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.clientId + '',
        schoolId: this.passenger.schoolId + ''
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    // this.deleteMarkers();
    this.passenger.busId = e.value;
  }

  FirstnamesChanged(InputValueString: any) {
    var TabNames = InputValueString.split("/");
    //console.log("Value recieved:" + InputValueString);
    //console.log("table length" + TabNames.length);
    if (TabNames.length == 1 ){
      this.passenger.count = 1;
    }else{
      var numberNamesValid : any = 0;
      for(var i = 0; i < TabNames.length;i++){
        //console.log("TabNames["+i+"] : " + TabNames[i] );
        if (TabNames[i] != "" && TabNames[i] != " "){
          numberNamesValid++;
          //console.log("IN");
        }
      }
      this.passenger.count = numberNamesValid;
    }
    //console.log("passenger.count :" + this.passenger.count);
  }

  subscriptionChanged(e: any) {
    this.passenger.subscription = e.value;
  }

  inscriptionStatusChanged(e: any) {
    this.passenger.inscriptionStatus = e.value;
  }

  initMap() {
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 0, lng: 0 };
    this.option = {
      center: pos,
      zoom: 8,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), this.option);
    this.markerBounds = new google.maps.LatLngBounds();
    if (this.school) {
      this.markerBounds.extend(new google.maps.LatLng(pos));
      const schoolMarker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: 'assets/images/markers/school.png',
      });
    }
    this.markers = [];
    this.setMarker();
  }
  setMarker() {
    const pos = { lat: Number(this.passenger.lng), lng: Number(this.passenger.lng) };
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.placeMarker(event);
    });
  }
  placeMarker(event) {
    if (this.markers[0]) {
      this.markers[0].setVisible(true);
      this.markers[0].setPosition(event.latLng);
    } else {
      const passangerMarker = new google.maps.Marker({
        position: event.latLng,
        map: this.map,
        icon: 'assets/images/markers/passenger.png',
        draggable: true,
        zIndex: 100,
      });
      this.markers.push(passangerMarker);
    }
    // Clear map link if position set by Maps
    this.passagerLinkMaps = "";

    this.passenger.lat = event.latLng.lat();
    this.passenger.lng = event.latLng.lng();
    google.maps.event.addListener(this.markers[0], 'dragend', (e) => {
      this.passenger.lat = e.latLng.lat();
      this.passenger.lng = e.latLng.lng();
    });
    if (this.passenger.lat != null && this.passenger.lng != null) {
      this.passenger.isPositionValide = true;
    }
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }


  changeHistoryJourney(){
    const inputFrom = this.getElapsedSecondsInDay(this.filterJourney.inputFrom);
    const inputTo   = this.getElapsedSecondsInDay(this.filterJourney.inputTo);
    if (inputFrom > inputTo) {
      this.filterJourney.inputTo = '';
    } else {
      this.filterJourney.timeInterval = [inputFrom, inputTo];
    }
  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  onFilterJourney() {
    this.JourneyloadData = true;
    //this.refreshMap();
    this.initMap();

    let params = new HttpParams({
      fromObject: {
        schoolId: this.passenger.schoolId + '',
        busIds: JSON.stringify([this.passenger.busId]),
        date: moment(this.filterJourney.date).format('YYYY-MM-DD'),
        timeInterval: JSON.stringify(this.filterJourney.timeInterval)
      }
    });
    let url = '/api/bus/mapJourney';

    this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.JourneyloadData = false;
            }
            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              if (positions.length > 0) {
                const color = '#34495e';
                this.createLineBus(data.buses[index], positions, this.map, color);
              }

            }
            this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.JourneyloadData = false;
          }
        );

  }

  addFirstname() {
    this.firstNamesRegistrationNumbers.push ( {firstname: '', RegistrationNumber: ''});
  }

  removeFirstname(index){
    this.firstNamesRegistrationNumbers.splice(index, 1);
  }


  updatePassengerFirstNamesRegistrationNumbers() {
    if (this.firstNamesRegistrationNumbers.length > 1) {
        this.passenger.firstnames = this.firstNamesRegistrationNumbers.map(item => item.firstname).join('/');
        this.passenger.registrationNumbers = this.firstNamesRegistrationNumbers.map(item => item.RegistrationNumber).join('/');
        this.passenger.count = this.firstNamesRegistrationNumbers.length;
    } else if (this.firstNamesRegistrationNumbers.length === 1) {
        this.passenger.firstnames = this.firstNamesRegistrationNumbers[0].firstname;
        this.passenger.registrationNumbers = this.firstNamesRegistrationNumbers[0].RegistrationNumber;
        this.passenger.count = 1;
    }
  }

  createLineBus(bus, locations, map, color) {
    const infowindow = new google.maps.InfoWindow();
    const path = [];
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0 ? true : false;
      const isLast = i === locations.length - 1 ? true : false;

      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(pos);

      let content = '';
      let label = null;
      let icon = null;
      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'JD';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'JA';
      } else if (locations[i].speed === 0) {
        icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            fillColor: '#F00',
            fillOpacity: 0.9
        };
      } else {
        icon = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3.5,
            strokeColor: '#ffffff',
            strokeWeight: 1,
            fillColor: color,
            fillOpacity: 0.9,
            rotation: locations[i].angle
        };
      }


      // window.alert(locations[i].angle);
      const marker = new google.maps.Marker({
          position: pos,
          map: map,
          label: label,
          icon: icon
       });
      this.markerBounds.extend(pos);

      const this_ = this;
      marker.addListener('click', function () {
        const position = locations[i].lat + ',' + locations[i].lng;

        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Position :</b> ${position} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
       });

      marker.addListener('mouseover', function() {
        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
      });
      marker.addListener('mouseout', function() {
        infowindow.close();
      });

      if (isLast) {
        this.JourneyloadData = false;
      }
    }
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    poly.setMap(map);

  }


  onLatLngChange() {
    if (this.passenger.lat != null && this.passenger.lng != null) {
      this.passenger.isPositionValide = true;
      this.markers[0].setVisible(true);
      this.markers[0].setPosition({
        lat: this.passenger.lat,
        lng: this.passenger.lng
      });
    } else {
      this.passenger.isPositionValide = false;
    }
  }

  extractNumbers(input: string): number[] {
    // Define a regular expression to match decimal numbers with optional negative sign
    const regex = /-?\d+(\.\d+)?/g;

    // Use the match method to find all matches in the input string
    const matches = input.match(regex);

    // Convert the matched strings to numbers and return the result
    return matches ? matches.map(Number) : [];
  }

  onLinkChange() {
    if (this.passagerLinkMaps != null && this.passagerLinkMaps != "") {
      
      // Extract latitude and longitude from the Google Maps link
      var splitUrl = this.passagerLinkMaps.split('!3d');
      var latLong = splitUrl[splitUrl.length-1].split('!4d');
      var lng;

      var lat = parseFloat(latLong[0]);

      var results = this.extractNumbers(latLong[1]);//Get numbers
      lng = results[0];//get the first nubmer

      //console.log(lat); 
      //console.log(lng); 

      // Check if latitude and longitude values are valid
      if (!isNaN(lat) && !isNaN(lng)) {

        // You now have the lat and lng values, you can use them as needed
        this.passenger.lat = lat;
        this.passenger.lng = lng;
        if (this.markers[0]) {
          this.markers[0].setVisible(true);
          this.markers[0].setPosition({
            lat: this.passenger.lat,
            lng: this.passenger.lng
          });
        } else {
          const passangerMarker = new google.maps.Marker({
            position: {lat: this.passenger.lat, lng: this.passenger.lng},
            map: this.map,
            icon: 'assets/images/markers/passenger.png',
            draggable: true,
            zIndex: 100,
          });
          this.markers.push(passangerMarker);
        }

        // Get the current date
        const currentDate = new Date();
        // Format the date as "dd:mm:yyyy"
        const formattedDate = `[${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}]`;
        // Concatenate the formatted date and the Google Maps link
        this.passenger.address = this.passenger.address + `\n${formattedDate} \nAdresse Maps: ${this.passagerLinkMaps}`;
        this.passenger.isPositionValide = true;
      } else {
        // Invalid link, show the invalid link message
        this.linkInvalide = 1;
        //Info ('Invalid Google Maps link');
        
      }
    } 
  }

  /* onLinkChange() {
    if (this.passagerLinkMaps != null && this.passagerLinkMaps != "") {
      
      // Extract latitude and longitude from the Google Maps link
      var splitUrl = this.passagerLinkMaps.split('!3d');
      var latLong = splitUrl[splitUrl.length-1].split('!4d');
      var lng;

      var lat = parseFloat(latLong[0]);

      var results = this.extractNumbers(latLong[1]);//Get numbers
      lng = results[0];//get the first nubmer

      //console.log(lat); 
      //console.log(lng); 

       // Calculate the haversine distance between the school and the passenger
       const distance = this.haversineDistance(
        { lat: this.school.lat, lon: this.school.lng },
        { lat: lat, lon: lng }
      );

      // Check if latitude and longitude values are valid
      if (!isNaN(lat) && !isNaN(lng)) {

        // Check if the distance is less than 30 km
        if (distance < 35) {
          // You now have the lat and lng values, you can use them as needed
          this.passenger.lat = lat;
          this.passenger.lng = lng;
          if (this.markers[0]) {
            this.markers[0].setVisible(true);
            this.markers[0].setPosition({
              lat: this.passenger.lat,
              lng: this.passenger.lng
            });
          } else {
            const passangerMarker = new google.maps.Marker({
              position: {lat: this.passenger.lat, lng: this.passenger.lng},
              map: this.map,
              icon: 'assets/images/markers/passenger.png',
              draggable: true,
              zIndex: 100,
            });
            this.markers.push(passangerMarker);
          }

          // Get the current date
          const currentDate = new Date();
          // Format the date as "dd:mm:yyyy"
          const formattedDate = `[${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}]`;
          // Concatenate the formatted date and the Google Maps link
          this.passenger.address = this.passenger.address + `\n${formattedDate} \nAdresse Maps: ${this.passagerLinkMaps}`;
          this.passenger.isPositionValide = true;
          this.linkInvalide = 0;
        } else {
          // Show an error message if the distance is greater than or equal to 30 km
          //console.log("Le passager se trouve à plus de 30 km de l'école.");
          alert("ERREUR: Cette position se trouve à plus de 35 km de l'école. Merci de verifier la positon");
          // Clear map link if position set by Maps
          this.passagerLinkMaps = "";
          this.linkInvalide = 1;
        }
      } else {
        // Invalid link, show the invalid link message
        this.linkInvalide = 1;
        //Info ('Invalid Google Maps link');
      }
    } 
  } 

  haversineDistance(
    coords1: { lat: number; lon: number },
    coords2: { lat: number; lon: number }
  ): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.toRadians(coords2.lat - coords1.lat);
    const dLon = this.toRadians(coords2.lon - coords1.lon);
    const lat1 = this.toRadians(coords1.lat);
    const lat2 = this.toRadians(coords2.lat);
  
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    return distance;
  }
  
  toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }*/

  checkPosition () {
    if (this.passenger.isPositionValide) {
      this.passenger.inscriptionStatus = 'Attente';
    } else {
      this.passenger.lat = 0;
      this.passenger.lng = 0;
      this.passenger.inscriptionStatus = 'PNV';
    }
    this.inscriptionTypeSelected = this.passenger.inscriptionStatus ;
  }

  phoneNumberPatternValidator() {
    const phoneNumberPattern = /^0[6-7]{1}[0-9]{8}$/;
    
    // Phone Driver check
    if (phoneNumberPattern.test(this.passenger.phone)) {
      this.phonePassagerInvalide = 0; // Valid pattern
    } else {
      this.phonePassagerInvalide = 1; // Invalid pattern
    }

  }

  checkFieldValidator () {
    this.phoneNumberPatternValidator(); // Check phone driver
    this.updatePassengerFirstNamesRegistrationNumbers();
    this.checkPositionDistance (); // check if distance with school is valid
  }

  checkPositionDistance () {
    if (this.passenger.isPositionValide){
      const distance = this.getDistanceFromLatLonInKm(this.school.lat, this.school.lng, this.passenger.lat, this.passenger.lng);
      // 1 if Invalid distance, show the invalid distance message
      this.distanceInvalid = distance > 35;
    } else {
      this.distanceInvalid = false;
    }
  }

  getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    const dLon = this.deg2rad(lon2 - lon1); 
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
    const distance = R * c; // Distance in km
    return distance;
  }
  
  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  initPosition(isChecked) {
    if (isChecked == false){
      this.passenger.lat = null;
      this.passenger.lng = null;
      this.passenger.isPositionValide = false;
       // Hide the marker
      if (this.markers.length > 0) {
        this.markers[0].setVisible(false);
      }
    }
  }

  deleteMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }

  am1Change($event) {
    this.passenger.am1Start = moment($event.from * 1000).format('X');
    this.passenger.am1End = moment($event.to * 1000).format('X');
  }
  am2Change($event) {
    this.passenger.am2Start = moment($event.from * 1000).format('X');
    this.passenger.am2End = moment($event.to * 1000).format('X');
  }
  pm1Change($event) {
    this.passenger.pm1Start = moment($event.from * 1000).format('X');
    this.passenger.pm1End = moment($event.to * 1000).format('X');
  }
  pm2Change($event) {
    this.passenger.pm2Start = moment($event.from * 1000).format('X');
    this.passenger.pm2End = moment($event.to * 1000).format('X');
  }

  formatDate(date) {
    let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  onSubmit(): void {
    if (this.passenger.subscription == 'Aller') {
      this.passenger.am2Start = moment('0000', 'hmm').format('X');
      this.passenger.am2End = moment('2359', 'hmm').format('X');
      this.passenger.pm2Start = moment('0000', 'hmm').format('X');
      this.passenger.pm2End = moment('2359', 'hmm').format('X');
    } else if (this.passenger.subscription == 'Retour') {
      this.passenger.am1Start = moment('0000', 'hmm').format('X');
      this.passenger.am1End = moment('2359', 'hmm').format('X');
      this.passenger.pm1Start = moment('0000', 'hmm').format('X');
      this.passenger.pm1End = moment('2359', 'hmm').format('X');
    }
    this.checkPosition();
    this.passenger.inscriptionType = 'new';
    this.passenger.inscriptionDate = moment().format('YYYY-MM-DD'); // today inscription

    // update first names and codes and number of passanger
    this.updatePassengerFirstNamesRegistrationNumbers();
    

    const q = new Date();
    const m = q.getMonth(); // Date object has month from 0-11
    const d = q.getDate();
    let y   = q.getFullYear();
    const DayRef = 1;
    const MonthRef = 6; // Le mois 7

    const DateRef       = new Date(y, MonthRef, DayRef);
    const Aujourdhuit   = new Date(y, m, d);

    if (Aujourdhuit > DateRef) {
        y = y + 1;
    }
    this.passenger.expirationDate = this.formatDate(new Date(y, MonthRef, DayRef));
    this.http.post(
      '/api/passenger/0',
      { passenger: this.passenger }
    ).subscribe(
      (passenger: Passenger) => {
        this.passenger = passenger;
        this.router.navigate(['/' + this.routeBase + '/subscription-view-passenger', this.passenger.id, 'last', this.PgLen]);
        //this.router.navigate(['/' + this.routeBase + '/subscription-list']);

      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription-add-passenger/subscription-add-passenger.component.ts